export const NETHERLANDS_ID = 'a0U2000000DuCWyEAN';
export const GERMANY_ID = 'a0U2000000DuCXDEA3';

export const ISO_CODE_NETHERLANDS = 'nl-NL';
export const ISO_CODE_GERMANY = 'de-DE';
